import TextareaAutosize from 'react-autosize-textarea'

/**
 * Textarea auto-ridimensionabile per la chat, allineata ai token del design system
 * @param {Object} props
 * @param {string} [props.placeholder] - Testo segnaposto
 * @param {Object} [props.style] - Stili inline aggiuntivi
 * @param {string} [props.value] - Valore controllato
 * @param {Function} [props.onChange] - Callback al cambio testo
 * @param {Function} [props.onKeyPress] - Callback alla pressione di un tasto
 * @param {boolean} [props.autoFocus] - Se true, mette il focus al mount
 * @param {boolean} [props.disabled] - Se true, disabilita l'input
 * @returns {JSX.Element}
 */
export const TextareaAuto = ({
  placeholder,
  style,
  value,
  onChange,
  onKeyPress,
  autoFocus,
  disabled,
  rows
}) => (
  <TextareaAutosize
    placeholder={placeholder || ''}
    style={{ ...styles.textAreaStyle, ...style }}
    autoFocus={autoFocus}
    value={value || ''}
    onChange={onChange}
    onKeyPress={onKeyPress}
    disabled={!!disabled}
    rows={rows}
  />
)

const styles = {
  textAreaStyle: {
    color: 'var(--ink-900)',
    width: '100%',
    height: 80,
    minHeight: 80,
    maxHeight: 450,
    paddingLeft: 10,
    paddingTop: 5,
    paddingRight: 10,
    paddingBottom: 5,
    borderRadius: 'var(--radius-md)',
    backgroundColor: 'var(--surface)',
    border: '1px solid var(--border)',
    boxShadow: 'none',
    resize: 'none',
    fontFamily: 'var(--font-family)',
    fontSize: '14px',
    outline: 'none'
  }
}
